import { http } from '@/lib/ats-https';

export const getThreads = async (applicationId: string) => {
  const response = await http.get(
    `/ats_applications/${applicationId}/application_assistant`
  );

  return response;
};

const getThreadMessages = async (applicationId: string, threadId: string) => {
  const response = await http.get(
    `/ats_applications/${applicationId}/application_assistant/${threadId}/messages`
  );

  return response;
};

const getMessageById = async (
  applicationId: string,
  threadId: string,
  messageId: string
) => {
  const response = await http.get(
    `/ats_applications/${applicationId}/application_assistant/${threadId}/messages/${messageId}`
  );

  return response;
};

const createMessage = async (
  applicationId: string,
  threadId: string,
  query: string,
  summary?: string
) => {
  const response = await http.post(
    `/ats_applications/${applicationId}/application_assistant/${threadId}/create_message`,
    summary?.length > 0 ? { query, summary } : { query }
  );

  return response;
};

const createThread = async (
  applicationId: string,
  query: string,
  summary?: string
) => {
  const response = await http.post(
    `/ats_applications/${applicationId}/application_assistant/create_message`,
    summary?.length > 0 ? { query, summary } : { query }
  );

  return response;
};

const sendMessage = async ({
  interviewId,
  payload,
}: {
  interviewId: string;
  payload: {
    message: string;
    send_to_candidate: boolean;
    user_ids: number[] | string[];
  };
}) => {
  const response = await http.post(
    `/ats_interviews/${interviewId}/send_message`,
    { ...payload }
  );

  return response;
};
const sendAIFeedback = async ({ ai_feedback }: { ai_feedback: any }) => {
  const response = await http.post(`/ai_feedback`, {
    ai_feedback,
  });

  return response;
};

const createSummary = async (applicationId: string, query: string) => {
  const response = await http.post(
    `/ats_applications/${applicationId}/application_assistant/create_summary`,
    { query }
  );

  return response;
};

const getSummaryById = async (applicationId: string, summaryId: string) => {
  const response = await http.get(
    `/ats_applications/${applicationId}/application_assistant/get_summary?summary_id=${summaryId}`
  );

  return response;
};

const POLLING_INTERVAL = 2000;
const MAX_POLLING_ATTEMPTS = 10;

const pollSummary = async (
  applicationId: string,
  summaryId: string
): Promise<any> => {
  let attempts = 0;

  while (attempts < MAX_POLLING_ATTEMPTS) {
    const response = await getSummaryById(applicationId, summaryId);

    if (response?.data?.status === 'completed') {
      return response;
    }

    if (response?.data?.errors?.length > 0) {
      return {
        data: {
          status: 'failed',
          errors: ['Unable to generate summary'],
        },
      };
    }

    attempts++;
    await new Promise((resolve) => setTimeout(resolve, POLLING_INTERVAL));
  }

  return {
    data: {
      status: 'failed',
      errors: ['Unable to generate summary'],
    },
  };
};

const getSummary = async (applicationId: string, query: string) => {
  const createResponse = await createSummary(applicationId, query);
  const summaryId = createResponse?.data?.summary_id;

  const summaryResponse = await pollSummary(applicationId, summaryId);

  return summaryResponse;
};

export const API_SERVICE = {
  getThreads,
  getThreadMessages,
  createMessage,
  createThread,
  sendMessage,
  sendAIFeedback,
  getMessageById,
  getSummary,
};
